<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetCtaWithParalaxaSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    description: '',
    bgColor: '#ffffff',
    image: null,
    buttonLink: '',
    buttonName: '',
    buttonBg: '#ffffff'
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <div class="widget-cta">
        <div class="widget-cta__box widget-cta__box--left">
            <IdeoFormGroup :label="$t('[[[Kolor tła]]]')" :invalid-feedback="form.$errors.first('settings.bgColor')" :state="form.$errors.state('settings.bgColor')">
                <IdeoFormInput v-model="form.settings.bgColor" type="color" name="settings.bgColor" />
            </IdeoFormGroup>
            <IdeoFormGroup :label="$t('[[[Obrazek]]]')" :invalid-feedback="form.$errors.first('settings.image')" :state="form.$errors.state('settings.image')">
                <IdeoFilePicker v-model="form.settings.image" media="images" />
            </IdeoFormGroup>
            <IdeoFormGroup :label="$t('[[[Link przycisku]]]')" :invalid-feedback="form.$errors.first('settings.buttonLink')" :state="form.$errors.state('settings.buttonLink')">
                <IdeoFormInput v-model="form.settings.buttonLink" type="text" name="buttonLink" />
            </IdeoFormGroup>
            <IdeoFormGroup :label="$t('[[[Nazwa przycisku]]]')" :invalid-feedback="form.$errors.first('settings.buttonName')" :state="form.$errors.state('settings.buttonName')">
                <IdeoFormInput v-model="form.settings.buttonName" type="text" name="buttonName" />
            </IdeoFormGroup>
            <IdeoFormGroup :label="$t('[[[Tło przycisku]]]')" :invalid-feedback="form.$errors.first('settings.buttonBg')" :state="form.$errors.state('settings.buttonBg')">
                <IdeoFormInput v-model="form.settings.buttonBg" type="color" name="buttonBg" />
            </IdeoFormGroup>
        </div>
        <IdeoFormGroup class="widget-cta__box widget-cta__box--right" :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('settings.description')" :state="form.$errors.state('settings.description')" required>
            <RichTextEditor id="description" v-model="form.settings.description" name="settings.description" />
        </IdeoFormGroup>
    </div>
</template>

<style lang="scss" scoped>
.widget-cta {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    &__box {
        &--left {
            order: 1;
        }
        &--right {
            order: 0;
        }
    }
}
</style>
